import type { FormInputProps } from '../FormInput';
import { FormInput } from '../FormInput';

export const IcNumberInput = (props: FormInputProps) => (
	<FormInput {...props} />
);
